class BattleHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-battle-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-battle-dot]'));
    this.prevBtn = this.querySelector('[data-battle-prev]');
    this.nextBtn = this.querySelector('[data-battle-next]');
    this.index = 0;
    this.intervalMs = Number(this.dataset.interval || 5000);
    this.autoplay = this.dataset.autoplay !== 'false';

    if (this.slides.length <= 1) return;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.restart();
      });
    });

    this.prevBtn?.addEventListener('click', () => {
      this.goTo(this.index - 1);
      this.restart();
    });

    this.nextBtn?.addEventListener('click', () => {
      this.goTo(this.index + 1);
      this.restart();
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => {
      if (this.autoplay) this.start();
    });

    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => {
      if (this.autoplay) this.start();
    });

    if (this.autoplay) this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  restart() {
    if (this.autoplay) this.start();
  }

  start() {
    this.stop();
    if (!this.autoplay || this.slides.length <= 1) return;
    this.timer = setInterval(() => this.goTo(this.index + 1), this.intervalMs);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  goTo(next) {
    const total = this.slides.length;
    this.index = ((next % total) + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
      slide.setAttribute('aria-hidden', i === this.index ? 'false' : 'true');
    });

    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
      dot.setAttribute('aria-current', i === this.index ? 'true' : 'false');
    });
  }
}

customElements.define('battle-hero', BattleHero);
